import styled from "styled-components";
import { Tag, Input, Button } from "antd";

export const HintText = styled.div`
  color: #1070b6;
  font-weight: bold;
  text-align: left;
  font-size: 16px;
  margin-bottom: 8px;
  cursor: pointer;
`;

export const AddPromoCodeTag = styled(Tag)`
  background: #fff;
  border-style: dashed;
  cursor: pointer;
`;

export const InlineInput = styled(Input)`
  /* background-color: #1070b6; */
  margin-right: 8px;
  vertical-align: top;
  height: 50px;
`;

export const PromoCodeDescription = styled.p`
  font-size: 12px;
  margin-top: 10px;
  font-weight: bold;
  font-style: italic;
`;

export const ApplyButton = styled(Button)`
  height: 50px;
  font-weight: bold;
  font-size: large;
  width: 45%;
  background-color: #d3e8ff;
  color: #1070b6;
`;

export const PromoCodeTag = styled(Tag)`
  height: 50px;
  width: 45%;
`;

export const StyledTag = styled(Tag)`
  height: 50px;
  width: 60%;
  overflow: hidden;
  &.ant-tag {
    border-width: 3px;
  }
  &.ant-tag > .anticon + span,
  .ant-tag > span + .anticon {
    font-size: 18px;
    font-weight: bold;
  }
  &.ant-tag > .ant-tag-close-icon {
    font-size: 15px;
    color: gray;
    float: right;
    margin-top: 2.5px;
  }
`;

export const CouponDescription = styled.div`
  font-weight: bold;
  text-align: left;
  font-size: 18px;
  margin-bottom: 8px;
  float: right;
  margin-top: 3%;
  margin-left: 4px;
`;

export const WhenMismatchedCurrency = styled.div`
  text-align: left;
  font-size: 13px;
  color: orange;
  float: left;
  margin-top: 10px;
`;
